import { AxiosError } from 'axios'

import consoleMessage from 'shared/utils/helpers/consoleMessage'
import isAxiosError from 'shared/utils/helpers/isAxiosError'
import { httpClient, pythonHttpClient } from 'shared/lib'

import {
   BuyNowServicePayload,
   CategoryType,
   ChangeCategoryPayload,
   EstablishCoopService,
   FormatResponsePayload,
   ProductDetails,
} from './types'

export async function fetchProductDetails(productId: string) {
   let errMessage = ''
   return httpClient
      .get<ProductDetails>(`products/${productId}`)
      .then((request) => {
         if (request.data) {
            return request.data
         }
         throw new Error('There is no data')
      })
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('PRODUCTS_DETAILS fetchProductDetails service', errMessage, 'error')
         throw error
      })
}

export function formatExternalAvailability(payload: FormatResponsePayload, productUuid: string) {
   let errMessage = ''
   return httpClient
      .post<CooperatingWholesaler>(`/products/${productUuid}/format-external-availability`, payload)
      .then((res) => res)
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('PRODUCTS_DETAILS formatExternalAvailability service', errMessage, 'error')
         throw error
      })
}

export async function getProductCategory(productId: string) {
   let errMessage = ''
   return pythonHttpClient
      .get<CategoryType>(`category/product/${productId}`)
      .then((request) => {
         if (request.data) {
            return request.data
         }
         throw new Error('There is no data')
      })
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('PRODUCTS_DETAILS getProductCategory service', errMessage, 'error')
         throw error
      })
}

export async function buyNowService(payload: BuyNowServicePayload) {
   let errMessage = ''
   return httpClient
      .post<BuyNowSummaryType>('/orders/buy-now', payload)
      .then((res) => res)
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('PRODUCTS_DETAILS buyNow service', errMessage, 'error')
         throw error
      })
}

export async function changeCategoryService(productUuid: string, payload: ChangeCategoryPayload) {
   let errMessage = ''
   return pythonHttpClient
      .patch<Result>(`category/product/${productUuid}`, payload)
      .then((res) => res)
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('PRODUCTS_DETAILS changeCategoryService service', errMessage, 'error')
         throw error
      })
}

export async function reportMissingProductService(payload: MissingProductsService) {
   let errMessage = ''
   return httpClient
      .post('/missingProducts', payload)
      .then((res) => res)
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('PRODUCTS_DETAILS reportMissingProducts service', errMessage, 'error')
         throw error
      })
}

export async function establishCooperationService(locationUuid: string, payload: EstablishCoopService) {
   let errMessage = ''
   return httpClient
      .post(`location/${locationUuid}/cooperation/establish/`, payload)
      .then((res) => res)
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('PRODUCTS_DETAILS establishCooperation service', errMessage, 'error')
         throw error
      })
}

export async function addToWatchlistService(productID: string) {
   let errMessage = ''
   return httpClient
      .post(`/products/observed/anyWholesale?productUuid=${productID}`)
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('PRODUCTS_DETAILS addToWatchlist service', errMessage, 'error')
         throw error
      })
}
